import styled, { css } from 'styled-components';

import themeColors from '@polyai/ui/styles/config/colors';
import themeSpacing from '@polyai/ui/styles/config/spacing';

export const TopBar = styled.div`
  display: flex;
  gap: ${themeSpacing.xs3};
  align-items: center;
  width: 100%;
`;

export const SliderWrapper = styled.div<{ $filledSegments: number }>`
  flex: 1;

  .minLabel,
  .maxLabel {
    display: none;
  }

  span[class*='Segments'] > span[class*='Segment']:not(:last-child) {
    margin-right: ${themeSpacing.xs1} !important;
  }

  ${({ $filledSegments }) =>
    $filledSegments > 0 &&
    css`
      ${Array.from({ length: $filledSegments }, (_, i) => i + 1)
        .map(
          n => `
        span[class*='Segments'] > span[class*='Segment']:nth-child(${n})
      `,
        )
        .join(',')} {
        background-color: ${themeColors.backgroundSuccess} !important;
      }
    `}

  input[type='range']::-webkit-slider-thumb {
    pointer-events: none;

    width: 0;
    height: 0;

    appearance: none;
    opacity: 0;
  }

  input[type='range']::-moz-range-thumb {
    pointer-events: none;

    width: 0;
    height: 0;

    appearance: none;
    opacity: 0;
  }

  input[type='range'] {
    pointer-events: none;
    cursor: default;
  }

  output {
    display: none !important;
  }
`;
